// extracted by mini-css-extract-plugin
export default {"btnContainer":"Kv4qCKgjHDXrbUsEdXoP"};